import { MenuOutlined } from "@ant-design/icons";
import { ButtonProps } from "antd";
import { FC } from "react";
import { useAppGlobStore } from "src/appGlobalStore";
import { XmButton } from "src/component/button/XmButton";
import "./HamburgerMenuButton.less";

const HamburgerMenuButton: FC<ButtonProps & { openLeftMenu: boolean; isInLeftMenu?: boolean; }> = ({ openLeftMenu, isInLeftMenu = false, ...props }) => {
  // Shows mobile left menu - hidden by default to hide slideOut animation on initial load
  function activateMobileLeftMenu() {
    const mobileLeftMenu = document.querySelector<HTMLElement>(".left-menu-mobile");
    if (!mobileLeftMenu) return;
    mobileLeftMenu.style.visibility = "visible";
  }

  return (
    <XmButton
      className={`hamburger-menu-button ${isInLeftMenu && 'hamburger-menu-button-in-left-menu'}`}
      onClick={() => {
        useAppGlobStore.setState({ isMobileLeftTreeOpen: openLeftMenu });
        activateMobileLeftMenu();
      }}
      {...props}
    >
      <MenuOutlined />
    </XmButton>
  );
};

export default HamburgerMenuButton;